import { IJWPAdvertising } from '../types'
import { getEmbedConfig } from '../util'
import { AbstractJWPlayer } from './abstract-jw-player'

export class JWStrategyPlayer extends AbstractJWPlayer {
    private jwStrategyPlaylistId: string | undefined
    private nonEditorial: string | undefined

    public constructor(protected element: HTMLElement) {
        super(element, {}, false)
        this.jwStrategyPlaylistId = this.element.dataset.jwStrategyPlaylistId
        this.nonEditorial = this.element.dataset.nonEditorial
    }

    /**
     * When the user meets the element on their screen,
     * load script and initialize the player.
     */
    public render(): void {
        void this.init()
    }

    public async init(): Promise<void> {
        const videoData = await this.getJWMediaMetadata()
        let advertConfig: IJWPAdvertising | undefined = undefined
        let midRolConfigData: IJWPAdvertising | undefined = undefined

        if (this.isMonetize(videoData)) {
            this.embedConfig = await getEmbedConfig()

            if (Object.keys(this.embedConfig).length) {
                const jwsrCustParam =
                    this.nonEditorial === 'true' ? { jwsr: 'yes' } : {}

                advertConfig = this.getAdvertisingConfigData(
                    this.embedConfig,
                    undefined,
                    this.loc,
                    {},
                    jwsrCustParam
                )

                midRolConfigData = this.getAdvertisingConfigData(
                    this.embedConfig,
                    undefined,
                    this.loc,
                    {
                        ad_rule: 0,
                        vpos: 'midroll'
                    },
                    {
                        vpos: 'midroll',
                        ...jwsrCustParam
                    }
                )
            }
        }

        const jwWrapper = document.createElement('div')
        const id = document.getElementById('jwp-placement-1')
        jwWrapper.id = id ? 'jwp-placement-2' : 'jwp-placement-1'
        const jwDataStoreScript = document.createElement('script')

        const params: Record<string, string | boolean> = {
            ad_tag: String(advertConfig?.schedule ?? '')
        }
        if (midRolConfigData) {
            params.mid_roll_ad_tag = String(midRolConfigData.schedule)
        }
        if (this.jwStrategyPlaylistId) {
            params.playlist_id = this.jwStrategyPlaylistId
        }
        if (this.videoId) {
            params.media_id = this.videoId
        }
        if (typeof this.autoplay !== undefined) {
            params.autostart = `${this.autoplay}`
        }
        params.s2n = !!document.querySelector('.s2nPlayer')
        const jwPlacement =
            jwWrapper.id === 'jwp-placement-1' ? '9ipu1Bmw' : 'C2LATgzS'
        jwDataStoreScript.innerHTML = `
            jwDataStore.custom["${jwPlacement}"] = ${JSON.stringify(params)};
            window.jwDataStore = jwDataStore;
        `

        jwWrapper.appendChild(jwDataStoreScript)
        const jwScript = document.createElement('script')
        jwScript.src = `https://cdn.jwplayer.com/v2/sites/ReDAXyY4/placements/${jwPlacement}/embed.js`
        jwWrapper.appendChild(jwScript)
        this.element.replaceWith(jwWrapper)

        // Change Title
        if (this.isFeatured) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    const element = mutation.target as HTMLElement
                    if (
                        mutation.type === 'childList' &&
                        element.classList.contains('jw-title-primary')
                    ) {
                        const title = element.innerHTML
                        this.changeStickyTitle(title)
                    }
                })
            })
            observer.observe(jwWrapper, {
                childList: true,
                subtree: true
            })
        }
        return Promise.resolve()
    }

    /**
     * Not implemented methods
     */
    setMute(): void {
        return
    }
    setControls(): void {
        return
    }
    setLoop(): void {
        return
    }
    setAutoplay(): void {
        return
    }
    get title(): string {
        return ''
    }
    get index(): number {
        return 0
    }
    pause(): void {
        return
    }
    play(): void {
        return
    }
    playVideoAt(): void {
        return
    }
    destroy(): void {
        return
    }
    getState(): string {
        return ''
    }
    isPausable(): boolean {
        return false
    }
    onError(): void {
        return
    }
}
